var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCourtroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-158-382H992v754H-158z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3,
    transform: "translate(22 26)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24.292,
    x: 28.5,
    y: 0.172,
    rx: 2,
    transform: "matrix(1 0 0 -1 0 24.636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16h82v8H0zM0 61.536h82v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 62h74V24H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 62h74V24H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 55.146h14V30.854H34zM14.5 55.146h14V30.854h-14zM53.5 55.146h14V30.854h-14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCourtroom);
export default __webpack_public_path__ + "static/media/icons-courtroom.a7a9d88325e612adb3806399feb8f599.svg";
export { ForwardRef as ReactComponent };